import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
// import { NotificationsService } from 'angular2-notifications';
// import { ToastrService } from 'ngx-toastr';
import { BaseDataService, NotificationService, QueryParameter } from 'yt-ng-framework';

@Component({
  selector: 'app-dodaj-rola-action',
  templateUrl: './dodaj-rola-action.component.html',
  styleUrls: ['./dodaj-rola-action.component.scss']
})
export class DodajRolaActionComponent implements OnInit {

  constructor(
    protected activeModal: NgbActiveModal,
    protected baseDataService: BaseDataService,
    // protected notificationService: NotificationsService
    protected toastrService: NotificationService
  )
  {
    
  }

  @Input() Parameters: QueryParameter[];

  ngOnInit(){
    this.formGroup.patchValue({RoleID: this.Parameters[0].Value});
    this.formGroup.patchValue({Value: false});
  }

  formGroup = new FormGroup({
    RoleID: new FormControl(),
    ActionID: new FormControl(),
    Value: new FormControl(),
  })

  Save(){
    this.baseDataService.Post('Action', 'AspNetRolesActionSave', this.formGroup.value, null)
      .subscribe(data =>{
        if(data){
          // this.notificationService.success('Uspeh!','Uspešno izmenjena vrednost akcije!');
          this.toastrService.success('Uspeh!','Uspešno izmenjena vrednost akcije!');
          this.Close();
        }
      })
  }

  Close(){
    this.activeModal.close();
}

}
